import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { AgGridReact } from 'ag-grid-react';
import { Reports, UserTypes, UserTypeMap } from 'data/user/constants';
import { List, Map } from 'immutable';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { getBrandCode, getBrandName, isReiAutomator, isElite, isProduction } from 'utils/brand';
import LoanApplication from 'app/components/LoanApplication';
import { gridValue, numberFormatter, currencyFormatter, percentFormatter, dateFormatter, properCaseFormatter, vacantFormatter, handleSurroundingTypeChange } from 'utils/grid';
import AddressLinkCellRenderer from 'utils/grid/addressLinkCellRenderer';
import { joinWith, toProperCase } from 'utils/string';
import { getPopupRegistration, openPopup, closePopup } from 'app/PopupHolder';
import withProperty from 'app/components/withProperty';
import { downloadReport, downloadPropertyData, purchaseReportAndLoad, selectDocumentLoading, selectTags, selectStatuses, selectOriginalLists, selectLoading, saveProperties, PropertyGroupTypes, updateSurroundingPropertySelection, selectPropertyContact, selectPropertyContactLoading, searchComparables, searchSurroundingProperties } from 'data/property';
import { selectPropertyDetailLayouts, selectUsers, selectProfile } from 'data/user';
import { selectPremiumReports, selectIsClickToDialLoaded } from 'data/user/selectors';
import { getSavedPropertyList } from "data/search";
import numberToPrice from 'utils/currency/numberToPrice';
import formatDate, { formatDateShort, formatDateYearMonth } from 'utils/date/formatDate';
import UserLogo from 'app/components/UserLogo';
import numberFormat, { formatYearMonth } from 'utils/number/format';
import percentFormat from 'utils/percent/formatPercent';
import formatFullAddressObject from 'utils/address/formatAddress';
import Modal from 'components/base/Modal';
import Button, { SolidButton } from 'components/Button';
import SVG from 'components/base/SVG';
import AnalysisButton from 'app/components/AnalysisButton';
import Chart from 'components/Chart';
import RestrictedContent from 'app/components/RestrictedContent';
import DetailsCustomTab from 'components/DetailsCustomTab';
import AddToGroup from 'app/components/AddToGroup';
import { selectSurroundingPropertyType, SurroundingPropertyContexts } from 'data/property';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import ProgressBar from 'components/ProgressBar';
import Confirm from 'app/components/Confirm';
import config from 'config';
import { isPropStream } from 'utils/brand';

import RentalROIIcon from '../../../assets/images/rental-roi-icon.svg';
import FixAndFlipIcon from '../../../assets/images/fix-and-flip-icon.svg';
import RehabIcon from '../../../assets/images/hammer-and-brush.svg';
import LoanGeekIcon from '../../../assets/images/loan-geek-logo-mark.svg';
import AduCalculatorIcon from '../../../assets/images/adu-calc-icon.svg';
import OfferAutomatorIcon from '../../../assets/images/offer-automator-logo.svg';

import ToolItemDropdown from './ToolItemDropdown';
import RentalROICalculator from 'app/components/PropertyTools/RentalROICalculator';
import FixFlipAnalyser from 'app/components/PropertyTools/FixFlipAnalyser';
import PropertyAIChat from 'app/components/PropertyTools/PropertyAIChat';
import ShadowCalculator from 'app/components/PropertyTools/ShadowCalculator';
import Tags from './Tags';
import PropertyComparables from './Comparables';
import PropertyDocuments from './Documents';
import Demographics from './Demographics';
import Panel from './Panel';
import PropertyGallery from '../Gallery/Gallery';
import GalleryCellRenderer from '../Surrounding/galleryCellRenderer';
import ValueCell from './valueCell';
import css from './style.scss';
import IndexCellRenderer from '../Surrounding/indexCellRenderer';
import IndexHeaderRenderer from '../Surrounding/indexHeaderRenderer';
import { TAX_COLUMNS, LEFT_FIELDS, RIGHT_FIELDS, COMP_FIELDS, MORTGAGE_FIELDS, OPPORTUNITY_FIELDS, GridProps, writeValues, writeSections, writeFields, writeTable } from './Table';
import DocumentImageCellRenderer from './documentImageCellRenderer';
import BedIcon from '../../../assets/images/Bed.svg';
import DropdownToggle from '../../../components/DropdownToggle';
import { trimAndAddEllipsis } from '../../../utils/string';
import { Permissions } from '../../../data/user/constants';
import MyBluebookButton from '../../components/MyBluebookButton';
// Circular Progress Bar for top section ui
import CircularProgressBar from '../../../components/CircularProgressBar';
import LoanGeekModal from './LoanGeekModal';
import AduCalculatorPopup from 'app/components/AduCalculator/AduCalculator';
// Intelligence Score Icons
import WholeHome from '../../../assets/images/wholehome.svg';
import IntelligenceIconSmall from '../../../assets/images/IntelligenceIcon_Small.svg';
import IntelligenceIconMedium from '../../../assets/images/IntelligenceIcon_Medium.svg';
import BathIcon from '../../../assets/images/Bath.svg';
import ForeclosureFactore from '../../../assets/images/foreclosure_factore.svg';
import Exterior from '../../../assets/images/exterior.svg';
import Interior from '../../../assets/images/interior.svg';
import Kitchen from '../../../assets/images/kitchen.svg';
import aISummary from '../../../assets/images/aISummary.svg';
// Components related Intelligence Bar and Intelligence Tab
import IntelliProgressBar from '../../../components/IntelliProgressBar';
import IntelligenceInfoCell from './IntelligenceInfoCell';
import IntelligenceValueCell from './IntelligenceCell';
import data from './IntelligenceDetails.json'
import foreclosureData from './IntelligenceForeclosureDetails.json'
import { isNDAState } from '../../../utils/ndaStates';
import infoGray from 'assets/images/info-gray.svg';
import dncIcon from 'assets/images/dnc-icon.svg';
import searchskiptrace from 'assets/images/search-skiptrace.svg';
import { selectPlanDetails, selectUsageSection } from '../../../data/user/selectors';
import LeaveMessagePopup from '../../AccountNew/modals/LeaveMessage';
import SkipTraceModal from 'app/components/SkipTraceModal';
import PurchaseSavesAndExportsPopup from "../../AccountNew/modals/PurchaseSavesAndExports";
import Tooltip from '../../components/Tooltip';
import { saveProperty } from 'data/property';
import AddToMarketingListModal from 'app/components/AddToMarketingListModal';
import { getAppendJobEstimate } from '../../../data/contacts/actions';
import { selectAppendGroups, selectAppendJob } from '../../../data/contacts';
import { getPropertyContact } from '../../../data/property/actions';
import SimpleModal from "components/base/SimpleModal";
import InfoAlert from '../../components/InfoAlert';
import softphoneService from "../../components/SoftphoneController/index.js";
import { openClickToDial } from "../../../data/user/actions.js";
import ClickToDial from '../../../components/ClickToDial/index.js';
import { isRedactedNumber, isRedactedOwner } from '../../../utils/contactUtil';

const taxPageFields = {
  sections: [{
    code: 'TOP',
    fields: [
      { name: 'Parcel Number', path: 'apn' },
      { name: 'Situs County', path: 'countyName' },
      { name: 'Situs County', path: 'countyName' },
      { name: 'Primary Owner Full Name', path: 'owner1FullName' },
      { name: 'Tax Bill Mailing Address', path: 'mailAddress', mask: '{address}' },
    ],
  }, {
    code: 'BOTTOM',
    fields: [
      { name: 'Tax Year', path: 'assessmentYear' },
      { name: 'Tax Amount', path: 'taxAmount', mask: '{currency}' },
      { name: 'Total Assessed Value', path: 'assessedValue', mask: '{currency}' },
      { name: 'Land Value', path: 'assessedLandValue', mask: '{currency}' },
      { name: 'Improvement Value', path: 'assessedImprovementValue', mask: '{currency}' },
    ]
  },
  ],
};

// Importing the intelligence score api
const {
  constants: {
    API: { INTELLIGENCE_URL },
  },
} = config;

const LinkedStats = [
  { field: 'quantity', label: 'Total Properties Owned' },
  { field: 'openMortgageBalance', label: 'Total Open Loan Amount' },
  { field: 'estimatedValue', label: 'Total Estimated Value' },
  { field: 'estimatedEquity', label: 'Portfolio Equity' },
];

const pageFields = 'PROPERTY_SALE:cashSale,MLS:mlsListing,MLS2:listhubMlsListing,FORECLOSURE,LIEN:liens,DIVORCE,BANKRUPTCY'
  .split(',').map(f => f.split(':')).reduce((m, f) => ({ ...m, [f[0]]: f[1] || f[0].toLowerCase() }), {});

let pageMap;

const getPage = (page, target) => {
  const { name, sections, code } = page;
  const preForeclosure = code === 'FORECLOSURE' && target && target.get('type') === 'P';
  const tab = {
    code,
    initialized: false,
    name: preForeclosure ? 'Pre-Foreclosure Details' : name,
    sections: [],
  };

  if (target) {
    const data = List.isList(target) && target.size === 1 ? target.get(0) : target;

    if (List.isList(data)) {
      tab.sections = data.reduce((m, d, i) => m.concat({
        // name: items.size > 1 ? name.replace(' Information', ` ${i + 1} Information`) : name,
        code: `${code}${i}`,
        caption: name.replace('Details', String(i + 1)),
        fieldQuantity: 1,
        fields: [{
          value: d,
          tab: getPage(page, d),
        }],
      }), []);
    } else {
      tab.sections = sections.map(({ name, code, fields }, si) => ({
        // name: items.size > 1 ? name.replace(' Information', ` ${i + 1} Information`) : name,
        name,
        code,
        caption: !si && preForeclosure ? `Current Pre-Foreclosure (${target.get('active') ? 'Active' : 'Inactive'})` : null,
        fieldQuantity: fields.length,
        fields: fields.map(({ name, path, mask, newLine }) => {
          let tab;
          let value = data.getIn(path.split('.'), null);
          const grid = mask === '{grid}';
          if (value != null && mask) {
            if (mask.startsWith('[')) tab = getPage(pageMap[mask.substr(1, mask.length - 2)], value);
            else if (mask.includes('{string}')) value = mask.replace('{string}', value);
            else if (mask.includes('{currency}')) value = mask.replace('{currency}', `${numberToPrice(value)}${data.get(`${path}Estimated`) ? '' : ''}`);
            else if (mask.includes('{date}')) value = mask.replace('{date}', formatDate(value, null, null, data.get(`${path}Format`)));
            else if (mask.includes('{yesno}')) value = mask.replace('{yesno}', value ? 'Yes' : 'No');
            else if (mask.includes('{number}')) value = mask.replace('{number}', numberFormat(value));
            else if (mask.includes('{percent}')) value = mask.replace('{percent}', percentFormat(value * 100));
            else if (mask.includes('{address}')) {
              value = mask.replace('{address}', formatFullAddressObject(value));

              const ownerPropertyId = data.get('ownerPropertyId');
              if (path === 'mailAddress' && ownerPropertyId && ownerPropertyId !== data.get('id')) value = <a href={`/search/${ownerPropertyId}`} target="_blank" rel="noreferrer">{value}</a>;
            } else if (grid) {
              // Give enough v-space for row detail expansion (used in PFC but not MLS currently).
              value = (
                <div className={classNames('ag-theme-balham', css.grid)} style={{ height: `${Math.min(300, 120 + (value.size * 30))}px` }}>
                  <AgGridReact {...GridProps[name]} rowData={value.toJS()} />
                </div>
              );
            }
          }

          return { name, value, tab, grid, newLine };
        }).filter(({ value, tab }) => (!tab && value != null) || (tab && tab.sections.length)),
      })).filter(section => section.fields.length);
    }
  }

  return tab;
};

const ownerNameFormatter = ({ value, data: { owner2FullName } }) => toProperCase(joinWith('\n', value, owner2FullName));
const stateCountyFormatter = ({ value, data: { countyName } }) => `${value || ''}/${countyName || ''}`;
const loanSequenceFormatter = d => `Loan ${d.value}`;
const yearMonthFormatter = d => formatYearMonth(d.value);
const estimatedAmountFormatter = (d, props) => {
  const ndaLabel = d.value && isNDAState(props.property.get('address').get('stateCode')) ? 'Est.' : '';
  return (d.value && `${numberToPrice(d.value)}${d.data.amountEstimated ? '' : ''} ${ndaLabel}`) || '';
}

const emptyFormatter = () => '';
let processingRows = false;

const MortgageGridProps = {
  getRowId: params => params.data.id,
  onRowGroupOpened: ({ api, data: { id }, node: { expanded } }) => {
    if (!processingRows && expanded) {
      processingRows = true;
      api.forEachNode((n) => { if (n.expanded && n.data.id !== id) n.setExpanded(false); });
      processingRows = false;
    }
  },
  domLayout: 'autoHeight',
  suppressCellFocus: true,
  suppressContextMenu: true,
  enableCellTextSelection: true,
  defaultColDef: { resizable: true, filter: true, sortable: true, menuTabs: [] },
  onFirstDataRendered: ({ api }) => api.sizeColumnsToFit(),
  columnDefs: [
    { headerName: 'Loan Position', field: 'seq', width: 100, suppressSizeToFit: true, resizable: false, suppressMovable: true, valueFormatter: loanSequenceFormatter },
    { headerName: 'Recording Date', field: 'loanRecordingDate', width: 110, suppressSizeToFit: true, valueFormatter: dateFormatter },
    { headerName: 'Document Number', field: 'documentNumber', cellRenderer: 'documentImageCellRenderer' },
    { headerName: 'Loan Type', field: 'loanType', width: 110, suppressSizeToFit: true },
    { headerName: 'Lender Name', field: 'lenderName', width: 150, suppressSizeToFit: true },
    { headerName: 'Loan Amount', field: 'amount', valueFormatter: currencyFormatter, width: 90, suppressSizeToFit: true },
    { headerName: 'Est. Rate', field: 'loanInterestRate', valueFormatter: percentFormatter, width: 70, suppressSizeToFit: true },
    { headerName: 'Type', field: 'financingType', width: 80, suppressSizeToFit: true },
    { headerName: 'Loan Term', field: 'loanTerm', width: 80, suppressSizeToFit: true },
    { headerName: 'Loan Due Date', field: 'loanDueDate', width: 100, suppressSizeToFit: true, valueFormatter: dateFormatter },
    { headerName: 'Est. Loan Payment', field: 'estimatedLoanPayment', valueFormatter: currencyFormatter },
    { headerName: 'Est. Loan Balance', field: 'estimatedLoanBalance', valueFormatter: currencyFormatter },
  ],
  components: {
    documentImageCellRenderer: DocumentImageCellRenderer,
  },
};

const TransactionGridProps = (props) => ({
  ...MortgageGridProps,
  columnDefs: [
    { headerName: '', field: 'id', width: 22, suppressSizeToFit: true, cellRenderer: 'agGroupCellRenderer', sortable: false, resizable: false, suppressMovable: true },
    { headerName: 'Recording Date', field: 'recordingDate', width: 115, suppressSizeToFit: true, valueFormatter: dateFormatter },
    { headerName: 'Sale Date', field: 'saleDate', width: 84, suppressSizeToFit: true, valueFormatter: dateFormatter },
    { headerName: 'Purchase Method', field: 'purchaseMethod', width: 115, suppressSizeToFit: true },
    { headerName: 'Document Number', field: 'documentNumber', width: 130, cellRenderer: 'documentImageCellRenderer', suppressSizeToFit: true },
    { headerName: 'Document Type', field: 'documentType', width: 110, suppressSizeToFit: true },
    { headerName: 'Transaction Type', field: 'transactionType', width: 120 },
    { headerName: 'Buyer Name(s)', field: 'buyerNames' },
    { headerName: 'Seller Name(s)', field: 'sellerNames' },
    { headerName: 'Amount', field: 'amount', width: 100, suppressSizeToFit: true, valueFormatter: (d) => estimatedAmountFormatter(d, props) },
  ],
  detailCellRendererParams: {
    detailGridOptions: {
      ...MortgageGridProps,
      columnDefs: [
        { headerName: '', headerClass: css.noBorder, field: 'id', width: 5, sortable: false, resizable: false, suppressMovable: true, suppressSizeToFit: true, valueFormatter: emptyFormatter },
        { headerName: 'Recording Date', field: 'loanRecordingDate', width: 110, suppressSizeToFit: true, valueFormatter: dateFormatter },
        { headerName: 'Document Number', field: 'documentNumber', width: 135, cellRenderer: 'documentImageCellRenderer', suppressSizeToFit: true },
        { headerName: 'Loan Type', field: 'loanType', width: 120 },
        { headerName: 'Loan Detail', field: 'loanDetail', width: 100, suppressSizeToFit: true },
        { headerName: 'Lender Name', field: 'lenderName', width: 300 },
        { headerName: 'Borrower Name(s)', field: 'buyerNames' },
        { headerName: 'Loan Term', field: 'loanTerm', width: 90, suppressSizeToFit: true },
        { headerName: 'Loan Due Date', field: 'loanDueDate', width: 110, suppressSizeToFit: true, valueFormatter: dateFormatter },
        { headerName: 'Loan Amount', field: 'amount', width: 105, suppressSizeToFit: true, valueFormatter: currencyFormatter },
      ],
    },
    getDetailRowData: ({ successCallback, data: { loans } }) => successCallback(loans),
  },
  masterDetail: true,
  getRowHeight: ({ node, data = {} }) => (node && node.detail && data.loans ? (data.loans.length * 30) + 75 : 30),
  isRowMaster: d => !!d.loans,
});

const fixedColumns = [
  { headerName: '', field: 'selected', width: 40, pinned: 'left', cellRenderer: 'indexCellRenderer', headerComponent: 'indexHeaderRenderer', sortable: false },
];

const LinkedPropertySubjectGridProps = {
  getRowId: params => params.data.id,
  // domLayout: 'autoHeight',
  suppressCellFocus: true,
  suppressContextMenu: true,
  enableCellTextSelection: true,
  defaultColDef: { resizable: true, filter: true, sortable: true, menuTabs: [] },
  onFirstDataRendered: ({ api }) => api.sizeColumnsToFit(),
  getRowHeight: () => 50,
  columnDefs: [
    { headerName: 'Address', field: 'streetAddress', width: 115, cellRenderer: 'addressLinkCellRenderer' },
    { headerName: 'Photo', field: 'imagePath', width: 50, suppressSizeToFit: true, cellRenderer: 'galleryCellRenderer' },
    { headerName: 'County', field: 'countyName', width: 115, suppressSizeToFit: true },
    { headerName: 'Beds', field: 'bedrooms', width: 40, suppressSizeToFit: true, valueFormatter: numberFormatter },
    { headerName: 'Baths', field: 'bathrooms', width: 46, suppressSizeToFit: true, valueFormatter: numberFormatter },
    { headerName: 'SqFt', field: 'squareFeet', width: 50, suppressSizeToFit: true, valueFormatter: numberFormatter },
    { headerName: 'Lot Size', field: 'lotSquareFeet', width: 80, suppressSizeToFit: true, valueFormatter: numberFormatter },
    { headerName: 'Property Type', field: 'landUse', width: 120, valueFormatter: properCaseFormatter },
    { headerName: 'Owner Names', field: 'owner1FullName', width: 120, valueFormatter: ownerNameFormatter },
    { headerName: 'Ownership Length', field: 'ownershipLength', width: 120, suppressSizeToFit: true, valueFormatter: yearMonthFormatter },
    { headerName: 'Current Loans', field: 'openMortgageBalance', width: 100, suppressSizeToFit: true, valueFormatter: currencyFormatter },
    { headerName: 'Est. Value', field: 'estimatedValue', width: 85, suppressSizeToFit: true, valueFormatter: currencyFormatter },
    { headerName: 'Occupancy', field: 'vacant', width: 70, suppressSizeToFit: true, valueFormatter: vacantFormatter },
  ],
  components: {
    indexCellRenderer: IndexCellRenderer,
    indexHeaderRenderer: IndexHeaderRenderer,
    addressLinkCellRenderer: AddressLinkCellRenderer,
    galleryCellRenderer: GalleryCellRenderer,
  },
};

export class PropertyDetail extends PureComponent {
  constructor(props) {
    super(props);

    this.handlePrint = this.handlePrint.bind(this);
    this.handleGridReady = this.handleGridReady.bind(this);
    this.handleDownloadData = this.handleDownloadData.bind(this);
    this.handleLoanApplicationClick = this.handleLoanApplicationClick.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOpenGallery = this.handleOpenGallery.bind(this);
    this.handleSaveLinkedList = this.handleSaveLinkedList.bind(this);
    this.handlePurchaseDocument = this.handlePurchaseDocument.bind(this);
    this.handleRehabCalculator = this.handleRehabCalculator.bind(this);
    this.handleOpenCompsTab = this.handleOpenCompsTab.bind(this);
    this.handlePSInfo = this.handlePSInfo.bind(this);
    this.closeDetailPopup = this.closeDetailPopup.bind(this);
    this.handleGetPropertyDetails = this.handleGetPropertyDetails.bind(this);
    this.handleLoanGeekClick = this.handleLoanGeekClick.bind(this);
    this.handleAduCalculator = this.handleAduCalculator.bind(this);
    this.shouldRenderClickToDial = this.shouldRenderClickToDial.bind(this);
    this.rentalROIRef = React.createRef();
    this.fixFlipRef = React.createRef();
    if (!pageMap && props.pages.size) pageMap = props.pages.toJS().reduce((m, p) => ({ ...m, [p.code]: p }), {});

    this.state = {
      selectedTabIndex: 0,
      currentPropertyId: null,
      currentGroupId: null,
      currentSavedPropertyIdForGroup: null,
      tabs: [],
      taxPage: { sections: [] },
      propertyDetails: null,  // intelligence score property details
      isPropExpanded: false,  // Flag for propperty condition expand
      isExpanded: false,      // Flag for foreclosure factor expand
      brandName: getBrandCode() === 'propstream' ? 'PropStream' : 'Property',
      showInfoPopup: null,
      showDNCPopup: null,
      showLitigatorPopup: false,
      showPropertyToolsModal: false,
      propertyToolsTab: 'rental',
      isSkipTraceLoading: false,
      isPropertyAIOpen: false
    };

    this.linkedPropertyGridProps = {
      ...LinkedPropertySubjectGridProps,
      onGridReady: this.handleGridReady,
      columnDefs: [
        ...fixedColumns,
        ...LinkedPropertySubjectGridProps.columnDefs.map(col => ({
          ...col,
          flex: 1,
          cellStyle: { 'white-space': 'nowrap', 'overflow': 'hidden' },
        })),
      ],
      context: {
        getSurroundingProps: () => ({
          ...this.props,
          context: SurroundingPropertyContexts.COMPARABLES,
          typeCode: 'LINKED',
          type: this.props.linkedType,
        }),
      },
    };
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  togglePropDropdown = () => {
    this.setState((prevState) => ({
      isPropExpanded: !prevState.isPropExpanded,
    }));
  };


  componentWillMount() {
    const { loadProperty, match, property, propertyId, getPropertyContact } = this.props;
    const id = match && match.params && match.params.id;
    if (id && Number(id) !== property.get('id')) {
      loadProperty(id);
    } else if (id) {
      getPropertyContact(id);
    }
    this.loadProperty(this.props);
    this.handleGetPropertyDetails(id);

    const currentGroupId = match && match.params && match.params.groupId;
    if (currentGroupId && Number(currentGroupId) > 0) {
      this.setState({ currentGroupId });

      this.props.getSavedPropertyList(id, (response) => {
        const propertyGroupsForProperty = response.response;
        const currentPropertyGroup = propertyGroupsForProperty.find((item) => Number(item.id) === Number(currentGroupId));
        if (currentPropertyGroup?.savedPropertyId) {
          this.setState({ currentSavedPropertyIdForGroup: Number(currentPropertyGroup.savedPropertyId) });
        }
      });
    }
  }

  componentDidMount() {
    if (this.props.location?.hash === '#documents-reports') {
      this.openDocumentsTabFromHash();
    }
  }

  componentWillReceiveProps(props) {
    this.loadProperty(props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.linkedType) {
      handleSurroundingTypeChange(this, this.props.linkedType);
    }

    if (this.props.location?.hash === '#documents-reports') {
      this.openDocumentsTabFromHash();
    }
  }

  handleOpenDocumentsTab = () => {
    this.handleTabSelect(this.getDocumentsTabIndex());
  };

  handleGetPropertyDetails(propertyId) {
    const url = `${INTELLIGENCE_URL}?property_id=${propertyId}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'x-auth-token': window.appAuthToken,
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json(); // Parse JSON directly
      })
      .then(jsonData => {
        if (jsonData) {
          this.setState({ propertyDetails: jsonData }); // Update state with fetched data
        } else {
          console.error('Empty response received');
        }
      })
      .catch(error => {
        console.error('Error fetching property details:', error);
      });
  }

  purchaseSavesAndExportsPopup = () => {
    const { purchaseSavesAndExportsPopup, usageSectionDetails } = this.props;
    purchaseSavesAndExportsPopup(usageSectionDetails);
  };


  loadProperty(props) {
    const { property, pages } = props;
    const currentPropertyId = property.get('id');

    if (!currentPropertyId) this.setState({ currentPropertyId: null, tabs: [{ name: 'Property Details', sections: [] }] });
    else if (pages.size && currentPropertyId !== this.state.currentPropertyId) {
      const taxPage = getPage(taxPageFields, property);
      if (!taxPage.sections.length) taxPage.sections.push({ fields: [] });
      taxPage.sections[0].name = 'Tax Details';
      this.setState({
        currentPropertyId,
        taxPage,
        tabs: pages.filter(p => !'LAST_SALE,LAST_TRANSFER'.includes(p.get('code'))).map(p => p.get('code')).map(code => getPage(pageMap[code], pageFields[code] ? property.get(pageFields[code]) : property)).filter(tab => tab.sections.length),
      });
    }
  }

  handleGridReady({ api }) {
    this.gridApi = api;
    this.dataVersion = 0;
    this.selectionVersion = 0;

    handleSurroundingTypeChange(this, this.props.linkedType);
  }

  handlePrint() {
    const { downloadReport, propertyId } = this.props;

    downloadReport(propertyId, Reports.comparativeMarketAnalysis);
  }

  handleDownloadData() {
    const { downloadPropertyData, propertyId } = this.props;
    downloadPropertyData(propertyId);
  }

  handleTabSelect(selectedTabIndex) {
    this.setState({ selectedTabIndex }, () => {
      // Perform tab initialization on first load. (Will need to run this somewhere else if first tab ever needs to init, but so far it's only MLS.)
      const { tabs } = this.state;
      const tab = List.isList(tabs) ? tabs.get(selectedTabIndex) : tabs?.[selectedTabIndex];
      if (tab && !tab.initialized && tab.code === 'MLS2') {
        tab.initialized = true;

        const listingKey = this.props.property.getIn(['listhubMlsListing', 'listingKey']);
        if (listingKey && window.listHub) window.listHub('submit', 'DETAIL_PAGE_VIEWED', { lkey: listingKey });
      }
    });
  }

  handleOpenGallery() {
    const { property, openPropertyGallery, zIndex } = this.props;
    // Forward our own (usually undefined) z-index so the gallery stacks above
    // this popup — see `parentZIndex` in Property/Gallery/Gallery.js.
    openPropertyGallery({ id: property.get('id'), parentZIndex: zIndex });
  }

  handleLoanApplicationClick() {
    const { openLoanApplication, property } = this.props;

    openLoanApplication({ property });
  }

  handleLoanGeekClick() {
    this.props.openLoanGeekModal({
      propertyId: this.props.propertyId
    });
  }

  handleAduCalculator() {
    if (!this.props.propertyId) return;
    this.props.openAduCalculator({
      propertyId: this.props.propertyId,
    });
  }

  handleSaveLinkedList() {
    const { lists, openAddToGroup, profile, linkedType } = this.props;

    openAddToGroup({
      selectLoading,
      groups: lists,
      addPropertyMode: true,
      size: linkedType.get('selection').size,
      limit: profile?.marketingListAddLimit,
      groupType: 'Marketing List',
      add: (name, onComplete) => this.saveLinkedProperties(PropertyGroupTypes.MARKETING, name, onComplete),
    });
  }

  saveLinkedProperties(groupType, groupName, onComplete) {
    const { linkedType, saveProperties } = this.props;
    const ids = linkedType.get('selection').map(p => [p.get('id')]).toJS();

    saveProperties(ids, groupName, groupType, null, ({ response: { quantity } }) => onComplete(quantity));
  }

  handlePurchaseDocument(transactions) {
    const { confirm, alert, report, checkSavedProperty, purchaseReportAndLoad } = this.props;
    if (transactions && transactions.length) {
      const { id, internalId } = transactions[0];
      checkSavedProperty(() => {
        confirm({
          question: `This report costs ${numberToPrice(report.get('price'))}. Click "Purchase" to accept the charge.
           If there is not a document available, you will not be charged.`,
          onOk: () => purchaseReportAndLoad(this.props.savedPropertyId, report.get('code'), report.get('price'), internalId, internalId ? null : id.substr(1), () => alert('Purchase successful! You can retrieve this report in the future via the Documents & Reports tab.')),
          okLabel: 'Purchase',
        });
      });
    }
  }

  handleRehabCalculator() {
    const { checkSavedProperty } = this.props;
    const buttonElement = document.getElementById('rehab-calculator');
    if (buttonElement) {
      buttonElement.click();
    }
  }

  handleOpenCompsTab() {
    const { tabs } = this.state;
    const openCompsTabIndex = List.isList(tabs) ? tabs.size : (tabs?.length || 0);
    this.handleTabSelect(openCompsTabIndex);
  }

  handlePSInfo() {
    const { tabs } = this.state;
    const openIntelligenceIndex = (List.isList(tabs) ? tabs.size : (tabs?.length || 0)) + 1;
    this.handleTabSelect(openIntelligenceIndex);
  }

  getDocumentsTabIndex() {
    const { tabs, propertyDetails } = this.state;
    const { linkedType, property } = this.props;

    const linkedProperties = linkedType.get('properties').toJS();
    const transactions = property.get('transactions', List()).toJS();

    const shouldHidePanel = !propertyDetails || [
      'propCondition',
      'interior',
      'exterior',
      'kitchen',
      'bathroom',
      'foreclosureFactor',
      'foreclosureFactorScore',
    ].every(field => !propertyDetails[field]);

    let index = List.isList(tabs) ? tabs.size : (tabs?.length || 0); // dynamic tabs count
    index += 1; // Comparables tab itself
    if (!shouldHidePanel) index += 1; // Intelligence
    index += 1; // Demographics
    index += 1; // Tax Information
    if (linkedProperties.length) index += 1; // Linked Properties
    if (transactions.length) index += 1; // Mortgage & Transaction History

    return index; // Documents & Reports
  }

  openDocumentsTabFromHash() {
    const { tabs } = this.state;
    const tabsCount = List.isList(tabs) ? tabs.size : (tabs?.length || 0);
    if (!tabsCount) return; // guard: wait for tabs to load

    const docsIndex = this.getDocumentsTabIndex();
    if (this.state.selectedTabIndex !== docsIndex) {
      this.handleTabSelect(docsIndex);

      this.props.history.replace(this.props.location.pathname);
    }
  }

  closeDetailPopup() {
    this.props.closePopup();
    if (!this.props.preventRouting) {
      this.props.history.push(location.pathname.substring(0, location.pathname.lastIndexOf("/")));
    }
  }

  // Add this method to get the base property path without any additional segments
  // Needs to support both ordinary search URLs and group URLs.
  getBasePropertyPath() {
    const { location } = this.props;
    const pathname = (location && location.pathname) || '';

    // Try to match a group route first: "/property/group/<groupId>/<id>"
    const groupMatch = pathname.match(/^(\/property\/group\/[0-9]+\/[0-9]+)/);
    if (groupMatch) {
      return groupMatch[1];
    }

    // Fallback to the normal search route: "/search/<id>"
    const searchMatch = pathname.match(/^(\/search\/[0-9]+)/);
    if (searchMatch) {
      return searchMatch[1];
    }

    // In case neither is present just return the current pathname (safe default)
    return pathname.split('?')[0];
  }

  determinePercentage = (value) => {
    const valueToFillMap = {
      1.0: 100, 1.1: 99, 1.2: 98, 1.3: 97, 1.4: 95, 1.5: 93, 1.6: 91, 1.7: 89, 1.8: 87, 1.9: 85,
      2.0: 83, 2.1: 81, 2.2: 79, 2.3: 77, 2.4: 75, 2.5: 73, 2.6: 71, 2.7: 69, 2.8: 67, 2.9: 65,
      3.0: 63, 3.1: 61, 3.2: 59, 3.3: 57, 3.4: 55, 3.5: 53, 3.6: 51, 3.7: 49, 3.8: 47, 3.9: 45,
      4.0: 43, 4.1: 41, 4.2: 39, 4.3: 37, 4.4: 35, 4.5: 33, 4.6: 31, 4.7: 29, 4.8: 27, 4.9: 25,
      5.0: 23, 5.1: 21, 5.2: 19, 5.3: 17, 5.4: 15, 5.5: 13, 5.6: 10, 5.7: 8, 5.8: 4, 5.9: 2, 6.0: 0
    };
    return valueToFillMap[value] || 0;
  }

  // `onStarted` (property AI chat only) runs once the Skip Trace modal has submitted the trace. It
  // doesn't run when the trace isn't started (no credits, no contact, estimate error, a trace already
  // in progress, or the modal is cancelled). The details-page button calls this with a click event.
  // `onFailed(status)` (chat only) runs when the trace didn't complete or its results couldn't be
  // loaded: the Skip Trace API status (NO_MATCH, DUPLICATE, …), 'ERROR', or 'RELOAD_ERROR'.
  // `onFinished` (chat only) runs once the contact has been reloaded after a completed trace.
  handleSkipTrace = ({ onStarted, onFinished, onFailed } = {}) => {
    if (this.state.isSkipTraceLoading) return;

    const {
      usageSectionDetails,
      leaveMessagePopup,
      SkipTraceModal: openSkipTraceModal,
      purchaseSavesAndExportsPopup,
      property,
      getAppendJobEstimate,
      appendGroups,
      openInfoAlert,
      propertySaved,
    } = this.props;

    if (usageSectionDetails?.id && usageSectionDetails?.savesRemaining <= 0 && !propertySaved) {
      leaveMessagePopup({
        title: "Not Enough Save Credits",
        message: "You don't have enough save credits to perform this action. Please purchase additional credits to continue.",
        yesLable: "Purchase Credits",
        cancelLabel: "Cancel",
        yesRedirect: () => purchaseSavesAndExportsPopup(),
      });
      return;
    }

    const contactInfo = property.toJS()?.contact;
    if (!contactInfo?.id) {
      if (typeof onFailed === 'function') onFailed('ERROR');
      return;
    }

    this.setState({ isSkipTraceLoading: true });

    const contactIds = [contactInfo.id];
    const mode = "BOTH";
    const reprocess = contactInfo?.appendedPhones ? true : false;

    getAppendJobEstimate(
      { contactIds, appendMode: mode, reprocessEnabled: reprocess },
      ({ response }) => {
        const { message } = response;
        if (message?.includes("There is an existing append job")) {
          openInfoAlert({
            title: "Skip Trace in Progress",
            infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
          });
          this.setState({ isSkipTraceLoading: false });
          return;
        }
        openSkipTraceModal({
          groups: appendGroups,
          reprocessEnabled: reprocess,
          contactIds,
          selectedProperties: 1,
          isPropertySkipTrace: true,
          onSuccess: () => {
            if (typeof onStarted === 'function') onStarted();
            this.props.getPropertyContact(
              property.get('id'),
              () => {
                this.setState({ isSkipTraceLoading: false });
                if (typeof onFinished === 'function') onFinished();
              },
              () => {
                this.setState({ isSkipTraceLoading: false });
                if (typeof onFailed === 'function') onFailed('RELOAD_ERROR');
              },
            );
          },
          // A trace that didn't complete (no match, already traced, error) still reloads the contact, as
          // the success path does: a duplicate returns cached data, and lastSkipTraceDate /
          // skipTraceInfoFound / "Re-Skip Trace" must not go stale. It also clears isSkipTraceLoading,
          // which used to stay on and block every later skip trace on this page.
          onFailure: (status) => {
            this.props.getPropertyContact(
              property.get('id'),
              () => {
                this.setState({ isSkipTraceLoading: false });
                if (typeof onFailed === 'function') onFailed(status);
              },
              () => {
                this.setState({ isSkipTraceLoading: false });
                // A duplicate's cached results can't be shown without the reload
                if (typeof onFailed === 'function') onFailed(status === 'DUPLICATE' ? 'RELOAD_ERROR' : status);
              },
            );
          },
          onCancel: () => this.setState({ isSkipTraceLoading: false }),
        });
      },
      // Estimate failures arrive here (the success callback never gets an error)
      (error) => {
        console.error("Error fetching estimate:", error);
        this.setState({ isSkipTraceLoading: false });
        if (typeof onFailed === 'function') onFailed('ERROR');
      }
    );
  }

  shouldRenderClickToDial() {
    const { profile } = this.props;
    if (!profile) return false;

    const userType = profile?.type;

    return ["FULL", "TEAM_FULL", "TEAM"].includes(userType);
  }

  handleAISummary = () => {
    this.setState({
      isPropertyAIOpen: true,
      runAISummary: true,
    });
  };

  closeTagsDropdown = null;

  registerCloseDropdown = (fn) => {
    this.closeTagsDropdown = fn;
  };

  render() {
    const { documentLoading, loading, saveProperty, match: { params }, location, property, profile, propertySaved, propertyId, savedPropertyId, checkSavedProperty, tags, users, statuses, linkedType, usageSectionDetails, planDetails, propertyContactLoading } = this.props;
    const { selectedTabIndex, tabs, taxPage, propertyDetails, isExpanded, isPropExpanded, brandName } = this.state;
    const btn = { loading };
    const imageUrls = property.has('imageUrls') ? property.get('imageUrls').split(',') : [property.get('mapUrl')];

    const tabProps = { property, propertyId, savedPropertyId, checkSavedProperty, saveProperty };
    const currentSavedPropertyId = this.state.currentGroupId ? this.state.currentSavedPropertyIdForGroup : savedPropertyId;
    const documentsTabProps = { ...tabProps, savedPropertyId: currentSavedPropertyId };

    const transactions = property.get('transactions', List()).toJS();
    const loans = property.get('activeLoans', List()).toJS();
    const oneYearValue = (property.getIn(['estimatedValueGraph', 'points'], List()).find(v => v.get('label') === '1yr') || Map()).get('value');
    const lastSale = property.get('lastSale', Map()).toJS();
    const ownerProperty = property.get('ownerProperty');
    const contactInformation = property.has('contact') ? property.get('contact') : null;
    const contactInfo = contactInformation && contactInformation?.toJS();
    const status = property.get('status');
    const { statusId, note, assignedTags, assignedUsers } =
      status && status.toJS ? status.toJS() : {};
    const linkedProperties = linkedType.get('properties').toJS();
    const prop = property.toJS();
    const members = (assignedUsers || []).map(id => users.find(r => r.get('id') === id)).filter(u => !!u);
    const percentage = propertyDetails ? this.determinePercentage(propertyDetails.propCondition_score) : 0;
    const chunkArray = (array, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    };
    const chunkedData = chunkArray(data, 3);
    const chunkedForeclosureData = chunkArray(foreclosureData, 3);

    const shouldHidePanel = !propertyDetails || [
      'propCondition',
      'interior',
      'exterior',
      'kitchen',
      'bathroom',
      'foreclosureFactor',
      'foreclosureFactorScore'
    ].every(field => !propertyDetails[field]);

    const linkedTotals = linkedProperties.reduce(({ quantity, openMortgageBalance, estimatedValue, estimatedEquity }, p) => ({
      quantity,
      openMortgageBalance: openMortgageBalance + (p.openMortgageBalance || 0),
      estimatedValue: estimatedValue + (p.estimatedValue || 0),
      estimatedEquity: estimatedEquity + ((p.estimatedValue || 0) - (p.openMortgageBalance || 0)),
    }), { quantity: linkedProperties.length, openMortgageBalance: 0, estimatedValue: 0, estimatedEquity: 0 });
    const ndaLabel = isNDAState(property.get('address').get('stateCode')) ? 'Est.' : '';

    const isPhoneNumberDNC = (contactInfo, phoneNumber) => {
      return contactInfo?.phones && Array.isArray(contactInfo?.phones) && contactInfo.phones.find((item) => item.phone == phoneNumber)
        ? contactInfo.phones.find((item) => item.phone == phoneNumber).dncPab == "D"
        : false;
    }

    const phoneNumberToOnlyNumeric = (phoneNumber) => {
      if (!phoneNumber || phoneNumber.length == 0) {
        return phoneNumber;
      }
      return phoneNumber.split("").filter((item) => !isNaN(item) && item.trim() != "").join("");
    }
    // Check if owner contact info is redacted for both owners and property is saved, if so, show skip trace button
    const isRedacted = isRedactedOwner(prop.owner1FullName, prop.owner2FullName)
    const showContactInfoSection = !(propertySaved && isRedacted)
    return (
      <>
        <Modal
          isOpen
          onClose={this.closeDetailPopup}
          isCloseButton
          customCloseBtnCls={css.detailCloseBtn}
          closeBtnStyle={{ top: '17px', right: '12px' }}
          background="#F3F5F8"
          uniqId="propertyDetail"
          width="1340px"
          // Undefined for every existing caller — Modal's own `zIndex ?? 999`
          // default applies exactly as before. Only a caller that explicitly
          // needs to stack above something with a higher hardcoded z-index
          // (e.g. opening this from inside another already-open modal, like
          // InvestorOutreach/Profile/PropertyTable.js does) passes one.
          zIndex={this.props.zIndex}
          caption={(
            <div className={css.header}>
              <div className={css.headerTitle}>{formatFullAddressObject(property.get('address'), true)}</div>
              <div className={css.buttons}>
                <Button {...btn} onClick={this.handleAISummary} className={css.aiSummaryButton}>
                  <img src={aISummary} alt="AI Summary" />
                  AI Summary
                </Button>
                <div className={css.dropDownToggle}>
                  <ToolItemDropdown
                    onToggle={() => {
                      if (this.closeTagsDropdown) {
                        this.closeTagsDropdown();
                      }
                    }}
                    items={[
                      {
                        name: "Rental ROI Calculator",
                        description: "Analyze rental property investment returns",
                        icon: RentalROIIcon,
                        isNew: true,
                        onClick: () => {
                          this.setState({ showPropertyToolsModal: true, propertyToolsTab: 'rental' });
                        },
                      },
                      {
                        name: "Fix & Flip Analyzer",
                        description: "Analyze deal profitability across purchase, holding, rehab & sale",
                        icon: FixAndFlipIcon,
                        isNew: true,
                        onClick: () => {
                          this.setState({ showPropertyToolsModal: true, propertyToolsTab: 'flip' });
                        },
                      },
                      {
                        name: "Rehab Calculator",
                        description: "Estimate costs for your next rehab project",
                        icon: RehabIcon,
                        onClick: () => {
                          this.handleRehabCalculator();
                        },
                      },
                      {
                        name: "ADU Calculator",
                        description: "Estimate costs for an ADU build",
                        icon: AduCalculatorIcon,
                        hidden: !this.props.propertyId,
                        onClick: () => {
                          this.handleAduCalculator();
                        },
                      },
                      {
                        name: "LoanGeek",
                        description: "Finance a real estate deal",
                        icon: LoanGeekIcon,
                        hidden: !this.props.propertyId,
                        onClick: () => {
                          this.handleLoanGeekClick();
                        },
                      },
                      {
                        name: "Offer Automator",
                        hidden: !isReiAutomator(),
                        description: "Calculate your maximum offer",
                        icon: OfferAutomatorIcon,
                        link: this.getBasePropertyPath() + '/offer',
                      },
                    ]}
                  />
                </div>
                <div className={css.panelButtons} style={{ display: 'none' }}>
                  <MyBluebookButton savedPropertyId={savedPropertyId} checkSavedProperty={checkSavedProperty} />
                </div>
                {isElite() ? null : <Tags registerCloseDropdown={this.registerCloseDropdown} address={formatFullAddressObject(property.get('address'), true)} isPropertyGroup={this.state.currentGroupId != null} currentSavedPropertyIdForGroup={this.state.currentSavedPropertyIdForGroup} onOpenDocumentsTab={this.handleOpenDocumentsTab} />}                <Button {...btn} loading={documentLoading} onClick={this.handlePrint} className={css.printButton}>
                  Print
                </Button>
                <AnalysisButton propertyId={propertyId} width="115px" params={params} location={location} className={css.AnalysisButton} />
                <Button {...btn} onClick={() => saveProperty(undefined, undefined, isRedacted)} disabled={propertySaved} className={css.SaveButton}>
                  {propertySaved ? 'Saved' : 'Save'}
                </Button>
              </div>
            </div>
          )}
        >
          <div className={css.propertyDetail}>
            <div className={css.rowPanels}>
              <Panel loading={loading}>
                <div className={css.propertyInfo}>
                  <div className={css.left}>
                    <div className={css.image} onClick={this.handleOpenGallery}>
                      <div className={css.pic} style={{
                        backgroundImage: imageUrls[0]
                          ? `url('${imageUrls[0]}')`
                          : 'none',
                      }} />
                      {imageUrls.length === 1 ? null : <div className={css.circle}>+{imageUrls.length - 1}</div>}
                    </div>
                    <div className={`${css.items} ${css.font600}`}>
                      <div className={`${css.item} ${css.bedBathItem}`}>
                        <div className={css.label}>
                          <img src={BedIcon} alt="Bed" />
                          <div className={css.span}>
                            <span>Beds</span>
                            <span>{property.get('bedrooms')}</span>
                          </div>
                        </div>
                        <div className={css.label}>
                          <img src={BathIcon} alt="Bath" />
                          <div className={css.span}>
                            <span>Baths</span>
                            <span>{property.get('bathrooms')}</span>
                          </div>
                        </div>
                      </div>
                      {writeFields(property, LEFT_FIELDS)}
                    </div>
                  </div>
                  <div className={classNames(css.right, css.items, css.font600)}>{writeFields(property, RIGHT_FIELDS)}</div>
                </div>
              </Panel>
              <Panel loading={loading}>
                <div className={css.valueGrid}>
                  <div className={css.valueSection}>
                    <div className={css.label}>Value</div>
                    <div className={css.values}>
                      <ValueCell name="Estimated Value" value={numberToPrice(property.get('estimatedValue'))} />
                      <ValueCell name={`Last Year (${formatDateYearMonth(moment().subtract(1, 'Y'))})`} value={numberToPrice(oneYearValue)} />
                    </div>
                    <div className={css.graph}>
                      <Chart yTickFormat={Chart.yTickFormat.currency} chartWidth={282} chartHeight={225} graph={property.get('estimatedValueGraph')} tickCount={3} isHighlightedLastDot />
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel loading={loading}>
                <div className={css.valueGrid}>
                  <div className={css.valueSection}>
                    {writeValues('Mortgage & Debt ', property, MORTGAGE_FIELDS)}
                    <div className={css.subLabel}>Last Sale</div>
                    <div className={css.values}>
                      <ValueCell name="Public Record" value={gridValue(lastSale, 'saleAmount')?.value ? `${currencyFormatter(gridValue(lastSale, 'saleAmount'))} ${ndaLabel}` : ''} description={dateFormatter(gridValue(lastSale, 'saleDate'))} />
                      <ValueCell name="MLS" value={currencyFormatter(gridValue(prop, 'mlsLastSaleAmount'))} description={dateFormatter(gridValue(prop, 'mlsLastSaleDate'))} />
                      <ValueCell addClass={`${css.flexBasis100} ${css.singleCell}`} name="Document Type" value={transactions && transactions.length ? trimAndAddEllipsis(transactions[0].documentType, 25) : 'N/A'} />
                    </div>
                  </div>
                  {!property.get('redacted') && <button className={css.cardsButton} onClick={() => this.handlePurchaseDocument(transactions)}>Purchase Document</button>}
                </div>
              </Panel>
              <Panel loading={loading}>
                <div className={css.valueGrid}>
                  <div className={css.valueSection}>
                    <div className={css.label}>Opportunity</div>
                    <div className={css.circularBarDiv}>
                      <CircularProgressBar percent={property.get('equityPercentage')} radius={29} strokeWidth={7} />
                      <div>
                        <div className={css.equityTxt}>Equity (est.)</div>
                        <ul className={css.barData}>
                          <li>{isNaN(property.get('estimatedEquity')) ? 'N/A' : numberToPrice(property.get('estimatedEquity'))}</li>
                          <li>{isNaN(property.get('equityPercentage')) ? 'N/A' : `${property.get('equityPercentage')}%`}</li>
                          <li>{property.get('dynamicWord') || 'N/A'}</li>
                        </ul>
                        {/* <ProgressBar percent={property.get('equityPercentage')} />*/}
                      </div>
                    </div>
                    <div className={css.values}>
                      <ValueCell
                        addClass={`${css.flexBasis100} ${css.singleCell}`}
                        name="Linked Properties"
                        value={numberFormat((property.get('linkedProperties') || List()).size)}
                      />
                      <ValueCell
                        addClass={`${css.flexBasis100} ${css.singleCell}`}
                        name="Est. Wholesale Price"
                        value={numberToPrice(property.get('estimatedValue') * 0.7)}
                      />
                    </div>
                    <div className={`${css.valuesWithLightBg} ${css.values}`}>
                      <ValueCell name="Monthly Rent" value={numberToPrice(property.get('rentAmount'))} />
                      <ValueCell
                        name="Gross yield"
                        value={percentFormat(Math.round(property.get('grossYield') * 10000) / 100)}
                      />
                    </div>
                    <div className={css.subLabel}>Comps at a Glance</div>
                    <div className={css.values}>
                      <ValueCell name="Avg. Sale Price" value={numberToPrice(property.get('compSaleAmount'))} />
                      <ValueCell
                        name="Days on Market"
                        value={property.get('compDaysOnMarket')}
                      />
                    </div>
                  </div>

                  <button className={css.cardsButton} onClick={this.handleOpenCompsTab}>Open Comps</button>
                </div>
              </Panel>
            </div>
            {/* Propstream Intelligence Tab */}
            {shouldHidePanel ? null : (
              <div className={css.intelligencePanel}>
                {propertyDetails ? (
                  <Panel loading={loading}>
                    <div className={css.intelligencePanelDiv}>
                      <div className={css.intelligenceIconDiv}>
                        <div className={css.intelligenceImg}>
                          <img src={IntelligenceIconMedium} alt="Intelligence" />
                        </div>
                        <div>
                          <p className={css.intelligenceTitleTop}>{brandName}</p>
                          <p className={css.intelligenceTitleBottom}>Intelligence</p>
                        </div>
                      </div>
                      <div className={css.intelligenceDetaials}>
                        <div className={css.intelligenceInfo}>
                          <p className={css.intelligenceInfoText}>Property <span className={css.intelligenceInfoIcon} onClick={this.handlePSInfo}>i</span></p>
                          <p className={css.intelligenceInfoText}>Condition</p>
                        </div>
                        <hr className={css.intelligenceInfoHr} />
                        <IntelligenceValueCell name="Total Condition" value={propertyDetails.propCondition} icon={WholeHome} score={propertyDetails.propCondition_score} />
                        <hr className={css.intelligenceInfoHr} />
                        <IntelligenceValueCell name="Exterior" value={propertyDetails.exterior} icon={Exterior} score={propertyDetails.exterior_score} />
                        <hr className={css.intelligenceInfoHr} />
                        <IntelligenceValueCell name="Interior" value={propertyDetails.interior} icon={Interior} score={propertyDetails.interior_score} />
                        <hr className={css.intelligenceInfoHr} />
                        <IntelligenceValueCell name="Kitchen" value={propertyDetails.kitchen} icon={Kitchen} score={propertyDetails.kitchen_score} />
                        <hr className={css.intelligenceInfoHr} />
                        <IntelligenceValueCell name="Bathroom" value={propertyDetails.bathroom} icon={BathIcon} score={propertyDetails.bathroom_score} />
                      </div>
                      <div className={css.intelligenceDetaials}>
                        <IntelligenceValueCell name="Foreclosure Factor" value={propertyDetails.foreclosureFactor} icon={ForeclosureFactore} score_percent={propertyDetails.foreclosureFactorScore ? propertyDetails.foreclosureFactorScore : 0} show_percent={false} use_score={false} />
                      </div>
                    </div>
                  </Panel>
                ) : (
                  <Panel loading={true}></Panel>
                )}
              </div>
            )}
            {!(statusId || note || assignedTags || assignedUsers) ? null : (
              <div className={css.status}>
                <div className={classNames(css.statusSide, css.statusLeft)}>
                  {!assignedTags && !statusId ? null : (
                    <Panel className={classNames(css.blueOutline, { [css.hidden]: !assignedTags }, css.statusTag)}>
                      <span className={css.statusLabel}>Property Tags: </span>
                      <span className={css.statusValue}>{assignedTags && assignedTags.reduce((tagList, id) => `${tagList}${tagList === '' ? '' : ', '}${(tags.find(g => g.get('id') === id) || Map()).get('name')}`, '')}</span>
                    </Panel>
                  )}
                  {!note && !assignedUsers ? null : (
                    <Panel className={classNames(css.blue, { [css.hidden]: !note }, css.statusNote)}>
                      <div className={css.statusLabel}>Note:</div>
                      <div dangerouslySetInnerHTML={{ __html: note }} />
                    </Panel>
                  )}
                </div>
                {!statusId && !assignedUsers ? null : (
                  <div className={classNames(css.statusSide, css.statusRight)}>
                    {!statusId && !assignedTags ? null : (
                      <Panel className={classNames(css.blueOutline, { [css.hidden]: !statusId })}>
                        <span className={css.statusLabel}>Status: </span>
                        {(statuses.find(s => s.get('id') === statusId) || Map()).get('name')}
                      </Panel>
                    )}
                    {!assignedUsers && !note ? null : (
                      <Panel className={classNames(css.blue, { [css.hidden]: !assignedUsers })}>
                        <div className={css.statusLabel}>Assigned Team Members:</div>
                        {members.map((u) => {
                          const id = u.get('id');
                          const type = UserTypeMap[u.get('type')] || UserTypeMap.FULL;

                          return (
                            <div className={css.member} key={id}>
                              <div>
                                <UserLogo id={u.get('id')} size={28} borderColor={type.colorDark} />
                                {u.get('name')}
                              </div>
                              <div>
                                <div className={css.memberTypeIcon} style={{ borderColor: type.colorDark, color: type.colorDark, backgroundColor: type.colorLight }}>{`${u.get('firstName', '').trim().substr(0, 1)}${u.get('lastName', '').trim().substr(0, 1)}`.toUpperCase()}</div>
                                <div>{type.label}</div>
                              </div>
                            </div>
                          );
                        })}
                      </Panel>
                    )}
                  </div>
                )}
              </div>
            )}
            <div className={css.tabs}>
              <DetailsCustomTab kind="line">
                <Tabs selectedIndex={selectedTabIndex} onSelect={this.handleTabSelect}>
                  <TabList className={classNames({ [css.disabledTabSection]: loading })}>
                    {tabs.map(({ name }) => (
                      <Tab key={name}>
                        <div className={css.tab}>
                          {name}
                        </div>
                      </Tab>
                    ))}
                    <Tab>
                      <div className={css.tab}>
                        Comparables &amp; Nearby Listings
                      </div>
                    </Tab>
                    {/* Intelligence Tab Header */}
                    {!shouldHidePanel && (
                      <Tab>
                        <div className={css.tab}>
                          <span className={css.intelliTab}>
                            <img src={IntelligenceIconSmall} alt="Intelligence" className={css.inteliiIcon} />Intelligence
                          </span>
                        </div>
                      </Tab>
                    )}
                    <Tab>
                      <div className={css.tab} id={'demographics_tab'}>
                        Demographics
                      </div>
                    </Tab>
                    <Tab><div className={css.tab}>Tax Information</div></Tab>
                    {!linkedProperties.length ? null : <Tab><div className={css.tab}>Linked Properties</div></Tab>}
                    {!transactions.length ? null : <Tab><div className={css.tab}>Mortgage &amp; Transaction History</div></Tab>}
                    <Tab><div className={css.tab}>Documents & Reports</div></Tab>
                  </TabList>
                  {tabs.map(({ name, sections }) => (

                    <TabPanel key={name}>
                      {name === 'Property Details' && propertyDetails && showContactInfoSection && (
                        <div className={css.contactsSection}>
                          <Panel className={(propertyContactLoading || loading) ? css.contactsPanelLoading : css.contactsPanel}>
                            {(propertyContactLoading || loading) ? (
                              <div className={css.loadingContactInfo}>
                                <SVG icon="spinner" className={classNames(css.spinnerContactInfo)} />
                              </div>
                            ) :
                              <>
                                {
                                  showContactInfoSection && <div>
                                    <div className={css.contactsHeader}>
                                      <span className={css.title}>Contact Information</span>
                                      <Tooltip title="Skip Trace"
                                        description={`Skip Trace finds phone numbers and emails for your prospects so you can call, text, or email them using ${getBrandName()}’s marketing tools.`}
                                        position="bottom"
                                        bgColor="#128292"
                                        width={312}
                                        xOffset={125}
                                        yOffset={2}
                                        arrowOffset={30}
                                      >
                                        <img src={infoGray} alt="info" className={css.infoIcon} />
                                      </Tooltip>
                                    </div>

                                    <div className={css.subTitle}>
                                      {contactInfo && property.get('lastSkipTraceDate') ? `Last Skip Trace: ${formatDate(property.get('lastSkipTraceDate'), null, null, 'MM/DD/YY')}` :
                                        getBrandCode() !== 'propstream' ? 'Skip Trace this property to obtain the contact information for the owner.' :
                                          usageSectionDetails?.savesRemaining <= 0 ? "You’ve used all free Skip Traces for your current billing cycle." :
                                            !planDetails?.trialAvailable ? "Access the contact information for this property at no cost." : "Skip Trace this property to view owner contact details."}
                                    </div>
                                    {contactInfo?.skipTraceInfoFound && <div className={css.noContactInfoText}>
                                      Sorry, no contact information available
                                    </div>
                                    }
                                    {
                                      !contactInfo?.skipTraceInfoFound && <>
                                        {
                                          !propertySaved && <button onClick={() => saveProperty(undefined, undefined, isRedacted)} className={css.skipTraceBtn} >
                                            <img src={searchskiptrace} alt="search" className={css.icon} />
                                            {loading && <SVG icon="spinner" className={classNames(css.spinner)} />}
                                            {!loading && "Save Property"}
                                          </button>
                                        }
                                        {
                                          propertySaved && (<button type="button" onClick={this.handleSkipTrace}
                                            disabled={this.state.isSkipTraceLoading}
                                            className={classNames(css.skipTraceBtn, {
                                              [css.disabledBtn]: this.state.isSkipTraceLoading,
                                            })}
                                          >
                                            <img src={searchskiptrace} alt="search" className={css.icon} />

                                            {this.state.isSkipTraceLoading ? (
                                              <SVG icon="spinner" className={classNames(css.spinner)} />
                                            ) : (
                                              contactInfo?.appendedPhones ? "Re-Skip Trace" : "Skip Trace"
                                            )}
                                          </button>
                                          )
                                        }
                                      </>
                                    }
                                  </div>
                                }


                                {contactInfo &&
                                  (contactInfo?.appendedPhones?.length > 0 ||
                                    contactInfo?.appendedEmails?.length > 0) && (
                                    <>
                                      <div className={css.userName}>
                                        {contactInfo?.name &&
                                          <Link
                                            to={`/contact/0/${contactInfo?.id}`}
                                            target="_blank"
                                            className={css.userName}
                                          >
                                            {contactInfo?.name}
                                          </Link>
                                        }
                                        {contactInfo?.litigatorFlag &&
                                          <Tooltip title="Litigator"
                                            description="A litigator is an individual who may be associated with legal actions, such as filing lawsuits related to telemarketing or consumer protection claims."
                                            position="top"
                                            width={312}
                                            arrowOffset={30}
                                            yOffset={-142}
                                            xOffset={124}
                                            bgColor="#128292"
                                          >

                                            <span onClick={() => this.setState({ showLitigatorPopup: true })} className={css.litigatorText}> {contactInfo?.litigatorFlag ? `(Litigator)` : ''} </span>
                                          </Tooltip>
                                        }
                                      </div>
                                      <div className={css.contactTable}>
                                        <table>
                                          <tbody>

                                            {/* PHONE ROWS */}
                                            {contactInfo?.appendedPhones?.slice(0, 5)?.map((item, index) => (
                                              <tr key={`phone-${index}`}>
                                                <td className={css.label}>Phone {index + 1}</td>
                                                <td className={css.value}> <span
                                                  className={this.props.isClickToDialLoaded && !isRedactedNumber(item.phone) ? css.clsPhoneNumberText : null}
                                                  onClick={() => {
                                                    if (this.props.isClickToDialLoaded && !isRedactedNumber(item.phone)) {
                                                      // const isDnc = isDncNumber(item.phone);
                                                      this.props.openClickToDial({
                                                        contactId: contactInfo?.id,
                                                        phonenumber: phoneNumberToOnlyNumeric(item.phone),
                                                        litigatorFlag: contactInfo?.litigatorFlag,
                                                        myDnc: item.myDNC,
                                                        publicDnc: item.publicDNC ?? isPhoneNumberDNC(contactInfo, item.phone),
                                                      });
                                                    }
                                                  }}

                                                >{item.phone}</span></td>
                                                <td className={css.type}>{item.type}</td>

                                                {/* <td>
                                      <Tooltip title="Confidence Score"
                                        description="On a scale of 1–100, higher scores indicate a greater likelihood of reaching the property owner through this number."
                                        position="top"
                                        bgColor="#128292"
                                        width={312}
                                        yOffset={-125}
                                        xOffset={-130}
                                        arrowOffset={290}
                                      >
                                      <span onClick={() => this.setState({ showInfoPopup: index })}  className={getScoreClass(item.score)}>
                                        {item.score}
                                      </span>
                                      </Tooltip>
                                    </td> */}

                                                <td >
                                                  {(item.dnc || item.publicDNC || item.myDNC) ?
                                                    <div className={css.dnc}>
                                                      <Tooltip title=""
                                                        content={
                                                          <div className={css.dncTextWrapper}>
                                                            {item.publicDNC && <div className={css.dncText}>Public DNC</div>}
                                                            {item.myDNC && <div className={css.dncText}>My DNC</div>}
                                                          </div>
                                                        }
                                                        position="bottom"
                                                        bgColor="#128292"
                                                        width={item?.myDNC && !item?.publicDNC ? 86 : 106}
                                                        yOffset={-12}
                                                        xOffset={20}
                                                        arrowOffset={20}
                                                      >
                                                        <img src={dncIcon} alt="dnc" className={css.dncicon} /> Do Not Call (DNC)
                                                      </Tooltip>

                                                    </div>

                                                    : "-"}
                                                </td>
                                              </tr>
                                            ))}

                                            {/* EMAIL ROWS */}
                                            {contactInfo?.appendedEmails?.slice(0, 2)?.map((item, index) => (
                                              <tr key={`email-${index}`}>
                                                <td className={css.label}>Email {index + 1}</td>
                                                <td className={css.value}>{item.email}</td>
                                                <td className={css.type}></td>
                                                <td></td>
                                                <td className={css.dnc}></td>
                                              </tr>
                                            ))}

                                          </tbody>
                                        </table>
                                      </div>
                                    </>
                                  )}
                              </>}
                          </Panel>
                        </div>
                      )}
                      {writeSections(property, sections)}
                    </TabPanel>
                  ))}
                  <TabPanel>
                    <PropertyComparables {...tabProps} />
                  </TabPanel>
                  {/* Intelligence Tab Content */}
                  {!shouldHidePanel && (
                    <TabPanel>
                      {propertyDetails ? (
                        <div>
                          <Panel className={css.intelliInfoSection}>
                            <div className={css.propConditionSection}>
                              <div className={css.propConditionTitle}>
                                <div>
                                  <div> <img src={IntelligenceIconMedium} alt="Intelligence" /></div>
                                </div>
                                <div>
                                  <div>
                                    <div className={css.propConditionHeader}>Property Condition</div>
                                  </div>
                                  <div className={css.propConditionRating}>
                                    <div className={css.propRatingHeader}>{propertyDetails.propCondition ? propertyDetails.propCondition : "N/A"}</div>
                                    <div><IntelliProgressBar percent={percentage} size={'big'} /></div>
                                  </div>
                                </div>
                              </div>
                              <div className={css.propSummary}>
                                Property condition is calculated using an AI algorithm that analyzes MLS photo data to estimate the overall quality of the property and its specific features (exterior, interior, kitchen, bathroom). The grading scale ranges from Disrepair (the lowest quality grade) to Luxury (the highest quality grade).
                              </div>
                            </div>
                            <hr />
                            <div>
                              <div className={css.intelliCol}>
                                <div className={css.intelliRow}>
                                  <IntelligenceInfoCell name="Exterior Condition" value={propertyDetails.exterior} icon={Exterior} score={propertyDetails.exterior_score} />
                                </div>
                                <hr className={css.intelligenceInfoHr} />
                                <div className={css.intelliRow}>
                                  <IntelligenceInfoCell name="Interior Condition" value={propertyDetails.interior} icon={Interior} score={propertyDetails.interior_score} />
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div>
                              <div className={css.intelliCol}>
                                <div className={css.intelliRow}>
                                  <IntelligenceInfoCell name="Kitchen Condition" value={propertyDetails.kitchen} icon={Kitchen} score={propertyDetails.kitchen_score} />
                                </div>
                                <hr className={css.intelligenceInfoHr} />
                                <div className={css.intelliRow}>
                                  <IntelligenceInfoCell name="Bathroom Condition" value={propertyDetails.bathroom} icon={BathIcon} score={propertyDetails.bathroom_score} />
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className={css.propConditionSection}>
                              <div className={css.intelliCol}>
                                <div className={css.intelliExpandRow}>
                                  <div className={css.intelliExpandText}>How To Interpret This Data</div>
                                  <div>
                                    <div
                                      onClick={this.togglePropDropdown}
                                      className={css.dropdownToggleBtn}
                                    >
                                      {isPropExpanded ? "Collapse" : "Expand"}
                                      <SVG
                                        icon={isPropExpanded ? "iconCaretUp" : "iconCaretDown"}
                                        className={css.dropdownCaretIcon}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {isPropExpanded && chunkedData.map((chunk, index) => (
                              <div key={index} className={css.wordScoreSection}>
                                {chunk.map((item, idx) => (
                                  <div key={idx} className={css.wordScoreCard}>
                                    <div className={css.wordScoreCardTop}>
                                      <div className={css.wordScoreLabel}>{item.label}</div>
                                      <div className={css.wordScoreBar}>
                                        <IntelliProgressBar percent={item.score} size={'medium'} />
                                      </div>
                                    </div>
                                    <div className={css.wordScorePoints}>
                                      <div className={css.custom_list}>
                                        <div className={css.custom_list_item}>{item.description.components}</div>
                                        <div className={css.custom_list_item}>{item.description.quality}</div>
                                        <div className={css.custom_list_item}>{item.description.rooms}</div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </Panel>
                          <Panel className={css.intelliInfoSection}>
                            <div className={css.propConditionSection}>
                              <div className={css.propConditionTitle}>
                                <div>
                                  <div> <img src={IntelligenceIconMedium} alt="Intelligence" /></div>
                                </div>
                                <div>
                                  <div>
                                    <div className={css.propConditionHeader}>Foreclosure Factor</div>
                                  </div>
                                  <div className={css.propConditionRating}>
                                    <div className={css.propRatingHeader}>{propertyDetails.foreclosureFactor || 'N/A'}</div>
                                    {/*<hr className={css.intelligenceDivHr} />*/}
                                    <div><IntelliProgressBar percent={propertyDetails.foreclosureFactorScore ? propertyDetails.foreclosureFactorScore : 0} size={'big'} /></div>
                                  </div>
                                </div>
                              </div>
                              <div className={css.propSummary}>
                                Foreclosure Factor utilizes a variety of data and Al-powered algorithms to predict a property's likelihood of going into default. The grading scale ranges from Very Low to Very High; the higher the score, the more likely the property will default within the next 12 months.
                              </div>
                            </div>
                            <hr />
                            <div className={css.propConditionSection}>
                              <div className={css.intelliCol}>
                                <div className={css.intelliExpandRow}>
                                  <div className={css.intelliExpandText}>How To Interpret This Data</div>
                                  <div>
                                    <div
                                      onClick={this.toggleDropdown}
                                      className={css.dropdownToggleBtn}
                                    >
                                      {isExpanded ? "Collapse" : "Expand"}
                                      <SVG
                                        icon={isExpanded ? "iconCaretUp" : "iconCaretDown"}
                                        className={css.dropdownCaretIcon}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {isExpanded && (
                              <div className={css.foreclosureSummary}>
                                The propensity to default (pre-foreclosure), is the likelihood that a homeowner will fall behind on their mortgage payments based on several factors (without personal identifying information - PII) including over 200 tax return line items, sources of income, and thousands of other data points. The propensity model also predicts the probability of default in the next 12 months based on elements such as home values, loan structure, and homeowner behavior.
                              </div>
                            )}
                            {isExpanded && chunkedForeclosureData.map((chunk, index) => (
                              <div key={index} className={css.wordScoreSection}>
                                {chunk.map((item, idx) => (
                                  <div key={idx} className={css.wordScoreCard}>
                                    <div className={css.wordScoreCardTop}>
                                      <div className={css.wordScoreLabel}>{item.label}</div>
                                      <div className={css.wordScoreBar}>
                                        <IntelliProgressBar percent={item.score} size={'medium'} />
                                      </div>
                                    </div>
                                    <div className={css.wordScorePoints}>
                                      <div className={css.custom_list}>
                                        {item.description.quality && (
                                          <div className={css.custom_list_item}>{item.description.quality}</div>
                                        )}
                                        {item.description.rooms && (
                                          <div className={css.custom_list_item}>{item.description.rooms}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </Panel>
                          <Panel className={css.intelliInfoSection}>
                            <h3 className={css.intelliHeader}>
                              About {brandName} Intelligence
                            </h3>
                            <p className={css.intelliHeaderInfo}>
                              {brandName} Intelligence leverages AI data and predictive analytics to assess and analyze properties to help enhance your decision-making process. Look for the {brandName} Intelligence <span><img src={IntelligenceIconSmall} alt="Intelligence" className={css.inteliiIcon} /></span>
                              icon to know you are working with intelligent data curated by AI to gain more leads and refine your search process.
                            </p>
                          </Panel>
                        </div>
                      ) : (
                        <Panel loading={true}></Panel>
                      )}
                    </TabPanel>
                  )}
                  <TabPanel>
                    <Demographics
                      property={property}
                      profile={profile}
                    />
                  </TabPanel>
                  <TabPanel className={css.tax}>
                    <Panel>
                      {writeSections(property, taxPage.sections)}
                      {writeTable(property.get('taxes'), TAX_COLUMNS, 'type_7')}
                    </Panel>
                  </TabPanel>
                  {!linkedProperties.length ? null : (
                    <TabPanel>
                      <div className={css.linkedProperties}>
                        <Panel>
                          <div className={css.summary}>
                            {LinkedStats.map((s, i) => (
                              <div className={css.summaryItem}>
                                <div className={css.summaryValue}>{(!i ? v => v : numberToPrice)(linkedTotals[s.field])}</div>
                                <div className={css.summaryLabel}>{s.label}</div>
                              </div>
                            ))}
                          </div>
                        </Panel>
                        {!ownerProperty ? null : (
                          <Panel>
                            <div className={css.heading}>Primary Property</div>
                            <div className="ag-theme-balham" style={{ height: 100 }}>
                              <AgGridReact {...LinkedPropertySubjectGridProps} rowData={[ownerProperty.toJS()]} />
                            </div>
                          </Panel>
                        )}
                        <Panel>
                          <div className={css.heading}>
                            <div>Current Linked Properties</div>
                            <Button {...btn} onClick={this.handleSaveLinkedList} disabled={!linkedType.get('selection').size}>Add to List</Button>
                          </div>
                          <div className="ag-theme-balham" style={{ height: `${Math.min(350, 120 + (linkedProperties.length * 50))}px` }}>
                            <AgGridReact {...this.linkedPropertyGridProps} />
                          </div>
                        </Panel>
                      </div>
                    </TabPanel>
                  )}
                  {!transactions.length ? null : (
                    <TabPanel>
                      {!loans.length ? null : (
                        <Panel>
                          <div className={css.heading}>Current Mortgages</div>
                          <div className="ag-theme-balham">
                            <AgGridReact {...MortgageGridProps} rowData={loans} />
                          </div>
                        </Panel>
                      )}
                      <Panel>
                        <div className={css.heading}>Transaction &amp; Mortgage History</div>
                        <div className={classNames('ag-theme-balham', css.transactions)}>
                          <AgGridReact {...TransactionGridProps(this.props)} rowData={transactions} />
                        </div>
                      </Panel>
                    </TabPanel>
                  )}
                  <TabPanel>
                    <PropertyDocuments {...documentsTabProps} />
                  </TabPanel>
                </Tabs>
              </DetailsCustomTab>
            </div>
          </div>
          {isPropStream() && this.shouldRenderClickToDial() && <ClickToDial profile={profile} />}
        </Modal>

        {ReactDOM.createPortal(
          <PropertyAIChat
            open={this.state.isPropertyAIOpen}
            setOpen={(open) => this.setState({ isPropertyAIOpen: open })}
            runAISummary={this.state.runAISummary}
            onAISummaryComplete={() =>
              this.setState({ runAISummary: false })
            }
            property={property}
            rentalRef={this.rentalROIRef}
            flipRef={this.fixFlipRef}
            calculatorsOpen={this.state.showPropertyToolsModal}
            onOpenCalculators={(tab) => this.setState({ showPropertyToolsModal: true, propertyToolsTab: tab || 'rental' })}
            onCloseCalculators={() => this.setState({ showPropertyToolsModal: false })}
            comparablesType={this.props.comparablesType}
            onOpenCompsTab={this.handleOpenCompsTab}
            isCompsTabActive={this.state.selectedTabIndex === (List.isList(this.state.tabs) ? this.state.tabs.size : (this.state.tabs?.length || 0))}
            linkedProperties={linkedType?.get('properties')}
            detailTabs={[...tabs, { name: 'Tax Information', sections: taxPage.sections }]}
            propertySaved={this.props.propertySaved}
            onSaveProperty={(onSaved) => this.props.saveProperty(undefined, undefined, isRedacted, onSaved)}
            onSkipTrace={this.handleSkipTrace}
            skipTraceCreditsRemaining={this.props.usageSectionDetails?.savesRemaining}
            loadComparables={() => {
              const search = this.props.comparablesType?.get('search')
              if (!search) return
              const propertyId = property.get('id')
              this.props.searchComparables(propertyId, SurroundingPropertyContexts.COMPARABLES, search, () => {
                this.props.searchSurroundingProperties(propertyId, SurroundingPropertyContexts.COMPARABLES, null, null)
              })
            }}
          />,
          document.body
        )}

        {this.state.showPropertyToolsModal && ReactDOM.createPortal(
          <div className={css.propertyToolsOverlay} onMouseDown={e => e.stopPropagation()}>
            <div className={css.propertyToolsDialog}>
              <div className={css.propertyToolsHeader}>
                <div className={css.propertyToolsHeaderLeft}>
                  <span className={css.propertyToolsTitle}>{formatFullAddressObject(property.get('address'), true)}</span>
                  <div className={css.propertyToolsStats}>
                    {[
                      { label: 'Beds', value: property.get('bedrooms'), icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="white"><path d="M1.25 1.875C1.25.84 2.09 0 3.125 0h13.75C17.91 0 18.75.84 18.75 1.875V8.168A5.01 5.01 0 0016.875 7.54V7.5c0-.005 0-.012 0-.012V5.25c0-.691-.559-1.25-1.25-1.25h-3.75c-.691 0-1.25.559-1.25 1.25V7.5h-1.25V5.25C9.375 4.559 8.816 4 8.125 4H4.375c-.691 0-1.25.559-1.25 1.25V7.5c0 .012 0 .027 0 .04A5.01 5.01 0 001.25 8.168V1.875zM0 12.5c0-2.07 1.68-3.75 3.75-3.75h12.5c2.07 0 3.75 1.68 3.75 3.75v6.25c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25V17.5h-15v1.25C2.5 19.441 1.941 20 1.25 20S0 19.441 0 18.75V12.5z" /></svg> },
                      { label: 'Baths', value: property.get('bathrooms'), icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="white"><path d="M3.75 3.02C3.75 2.734 3.98 2.5 4.27 2.5c.136 0 .27.055.367.152l.582.582A4.99 4.99 0 005 4.375c0 .777.281 1.484.75 2.031-.207.36-.156.824.148 1.133.368.367.961.367 1.325 0l4.066-4.063c.367-.367.367-.96 0-1.324-.31-.309-.773-.355-1.133-.148A3.72 3.72 0 008.125 1.25c-.402 0-.789.078-1.141.215l-.582-.582A2.49 2.49 0 004.27 0C2.6 0 1.25 1.352 1.25 3.02V10c-.691 0-1.25.559-1.25 1.25S.559 12.5 1.25 12.5h17.5c.691 0 1.25-.559 1.25-1.25S19.441 10 18.75 10H3.75V3.02z" /><path d="M1.25 13.75v.625c0 1.11.484 2.11 1.25 2.797v1.578C2.5 19.441 3.059 20 3.75 20s1.25-.559 1.25-1.25v-.625h10v.625c0 .691.559 1.25 1.25 1.25s1.25-.559 1.25-1.25v-1.578c.766-.688 1.25-1.688 1.25-2.797v-.625H1.25z" /></svg> },
                      { label: 'SqFt', value: property.get('squareFeet') ? numberFormat(property.get('squareFeet')) : null, icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="1" y="1" width="18" height="18" rx="2" stroke="white" strokeWidth="2" /><path fillRule="evenodd" clipRule="evenodd" d="M9.5 4H8C6.895 4 6 4.895 6 6v1.5h2V6h1.5V4zM6 10.5V12c0 1.105.895 2 2 2h1.5v-2H8v-1.5H6zM12.5 4V6H14v1.5h2V6c0-1.105-.895-2-2-2h-1.5zM16 10.5H14V12h-1.5v2H14c1.105 0 2-.895 2-2v-1.5z" fill="white" /></svg> },
                      { label: 'Lot Size', value: property.get('lotSquareFeet') ? numberFormat(property.get('lotSquareFeet')) : null, icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="1" y="1" width="18" height="18" rx="2" stroke="white" strokeWidth="2" strokeDasharray="4 4" /><rect x="6" y="6" width="8" height="8" rx="1" stroke="white" strokeWidth="1.5" /></svg> },
                      { label: 'Year Built', value: property.get('yearBuilt') },
                      { label: 'Est. Value', value: property.get('estimatedValue') ? numberToPrice(property.get('estimatedValue')) : null },
                    ].filter(s => s.value).map(s => (
                      <span key={s.label} className={css.propertyToolsStat}>
                        {s.icon && <span className={css.propertyToolsStatIcon}>{s.icon}</span>}
                        <span className={css.propertyToolsStatValue}>{s.value}</span>
                        <span className={css.propertyToolsStatLabel}>{s.label}</span>
                      </span>
                    ))}
                  </div>
                </div>
                <button
                  className={css.propertyToolsClose}
                  onClick={() => this.setState({ showPropertyToolsModal: false })}
                >
                  ✕
                </button>
              </div>
              <DetailsCustomTab kind="default" className={css.propertyToolsTabsWrapper}>
                <Tabs
                  selectedIndex={this.state.propertyToolsTab === 'rental' ? 0 : 1}
                  onSelect={(i) => this.setState({ propertyToolsTab: i === 0 ? 'rental' : 'flip' })}
                >
                  <TabList>
                    <Tab>Rental ROI Calculator</Tab>
                    <Tab>Fix &amp; Flip Analyzer</Tab>
                  </TabList>
                  <TabPanel>
                    <div className={css.propertyToolsModalBody}>
                      <ShadowCalculator>
                        <RentalROICalculator
                          ref={this.rentalROIRef}
                          initialListingPrice={property.get('estimatedValue') || undefined}
                          initialYearBuilt={property.get('yearBuilt') || undefined}
                          initialRentMonthly={property.get('rentAmount') || undefined}
                          initialPropertyTax={property.get('taxAmount') || undefined}
                          address={formatFullAddressObject(property.get('address'), true)}
                        />
                      </ShadowCalculator>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className={css.propertyToolsModalBody}>
                      <ShadowCalculator>
                        <FixFlipAnalyser
                          ref={this.fixFlipRef}
                          initialPurchasePrice={property.get('estimatedValue') ? property.get('estimatedValue') * 0.7 : undefined}
                          initialSalePrice={property.get('estimatedValue') || undefined}
                          initialPropertyTax={property.get('taxAmount') || undefined}
                          address={formatFullAddressObject(property.get('address'), true)}
                        />
                      </ShadowCalculator>
                    </div>
                  </TabPanel>
                </Tabs>
              </DetailsCustomTab>
            </div>
          </div>,
          document.body
        )}

      </>
    );
  }
}

const PropertyDetailPopup = withProperty(PropertyDetail, state => ({
  documentLoading: selectDocumentLoading(state),
  pages: selectPropertyDetailLayouts(state),
  tags: selectTags(state),
  statuses: selectStatuses(state),
  users: selectUsers(state),
  profile: selectProfile(state),
  report: selectPremiumReports(state).find(r => r.get('code') === 'DOCUMENT_IMAGE'),
  linkedType: selectSurroundingPropertyType(state, SurroundingPropertyContexts.COMPARABLES, 'LINKED'),
  comparablesType: selectSurroundingPropertyType(state, SurroundingPropertyContexts.COMPARABLES),
  lists: selectOriginalLists(state),
  usageSectionDetails: selectUsageSection(state),
  planDetails: selectPlanDetails(state)?.toJS(),
  appendJob: selectAppendJob(state).toJS(),
  appendGroups: selectAppendGroups(state),
  propertyContact: selectPropertyContact(state),
  propertyContactLoading: selectPropertyContactLoading(state),
  isClickToDialLoaded: selectIsClickToDialLoaded(state),
}), {
  getPropertyContact,
  downloadReport,
  downloadPropertyData,
  selectLoading,
  saveProperties,
  getAppendJobEstimate,
  updateSurroundingPropertySelection,
  searchComparables,
  searchSurroundingProperties,
  getSavedPropertyList,
  openClickToDial,
  openPropertyGallery: PropertyGallery.open,
  openLoanApplication: LoanApplication.open,
  openAddToGroup: AddToGroup.open,
  purchaseReportAndLoad,
  confirm: Confirm.open,
  alert: Confirm.alert,
  leaveMessagePopup: LeaveMessagePopup.open,
  SkipTraceModal: SkipTraceModal.open,
  purchaseSavesAndExportsPopup: PurchaseSavesAndExportsPopup.open,
  openAddToMarketingListModal: AddToMarketingListModal.open,
  openInfoAlert: InfoAlert.open,
  openLoanGeekModal: LoanGeekModal.open,
  openAduCalculator: AduCalculatorPopup.open,
});

const registrationId = getPopupRegistration(PropertyDetailPopup);

PropertyDetailPopup.open = props => {
  console.log('PropertyDetailPopup.open called with props:', props);
  return openPopup(registrationId, props);
};
PropertyDetailPopup.close = () => closePopup({ popup: registrationId });

export default withRouter(PropertyDetailPopup);
